// extracted by mini-css-extract-plugin
export default {"backdrop":"stackableDialog_backdrop__IcZY5"};